

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DOWNLOADKRAKPIS= createAsyncThunk(
  "downloadAllKraKpis/downloadAllKraKpis",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const downloadAllKraKpisSlice = createSlice({
  name: "downloadAllKraKpisSlice",
  initialState: {
    downloadAllKraKpis: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdownloadAllKraKpis: (state) => {
        state.downloadAllKraKpis.loading = false
        state.downloadAllKraKpis.error = false
        state.downloadAllKraKpis.data = []
        state.downloadAllKraKpis.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DOWNLOADKRAKPIS.fulfilled, (state, action) => {
      state.downloadAllKraKpis = {
        ...state.downloadAllKraKpis,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADKRAKPIS.pending, (state, action) => {
      state.downloadAllKraKpis = {
        ...state.downloadAllKraKpis,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DOWNLOADKRAKPIS.rejected, (state, action) => {
      state.downloadAllKraKpis = {
        ...state.downloadAllKraKpis,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const downloadAllKraKpisAction = {
    DOWNLOADKRAKPIS,
};

export { downloadAllKraKpisAction };
export default downloadAllKraKpisSlice.reducer;
export const {setInitialStateOfdownloadAllKraKpis} = downloadAllKraKpisSlice.actions
